import ClockLoader from "react-spinners/ClockLoader";

/**
 * Generic page/tile loader matching the parent SPA ClockLoader overlay.
 */
const Loader = ({
  loading = false,
  loadingMessage,
  overlay = true,
  size = 100,
  color = "#dc6258",
}) => {
  if (!loading) return null;

  const spinner = (
    <div className="edsimsV2-loader">
      <ClockLoader size={size} color={color} loading={loading} />
      {loadingMessage ? (
        <h2 className="edsimsV2-loader-message">{loadingMessage}</h2>
      ) : null}
    </div>
  );

  if (!overlay) return spinner;

  return (
    <div
      className="edsimsV2-loader-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="edsimsV2-sr-only">Loading</span>
      {spinner}
    </div>
  );
};

export default Loader;
